const listaDePerfis = (state) => {
    return state.items || [];
}

const loadingPerfil = (state) => {
    return state.buscando
}

export {
    loadingPerfil,
    listaDePerfis,
}